module.exports = __webpack_public_path__ + "static/img/selDayBorder.f3f4a32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selDayBorder.png
// module id = cWSY
// module chunks = 1